import { Directive } from '@angular/core';
import { BrnComboboxChipInput } from '@spartan-ng/brain/combobox';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
	selector: 'input[hlmComboboxChipInput]',
	hostDirectives: [{ directive: BrnComboboxChipInput, inputs: ['id', 'aria-invalid'] }],
	host: { 'data-slot': 'combobox-chip-input' },
})
export class HlmComboboxChipInput {
	constructor() {
		classes(() => 'spartan-combobox-chip-input min-w-16 flex-1 outline-none');
	}
}
